/* Единый источник метаданных карточки: объём, бейджи, цена. */

export const BESTSELLER_IDS = new Set(['14765628', '14765504']);

const VOLUME_RE = /(\d{1,4}(?:[.,]\d+)?)\s*(мл|ml|г|гр)\b/i;
const UNIT_NORM = { ml: 'мл', мл: 'мл', гр: 'г', г: 'г' };

export function productVolume(p) {
    if (!p) return '';
    const fromSheet = String(p.volume || '').trim();
    if (fromSheet) return fromSheet;
    if (/набор/i.test(p.category || '')) return '';
    const m = `${p.name || ''} ${p.description || ''}`.match(VOLUME_RE);
    if (!m) return '';
    const unit = UNIT_NORM[m[2].toLowerCase()] || m[2];
    return `${m[1]} ${unit}`;
}

export function productBadges(p) {
    if (!p) return [];
    const fromSheet = Array.isArray(p.badges) ? p.badges.filter(Boolean) : [];
    if (fromSheet.length) return fromSheet;
    return BESTSELLER_IDS.has(String(p.id)) ? ['БЕСТСЕЛЛЕР'] : [];
}

/* НОВОЕ: получить price_info с сервера или фолбэк на p.price */
export function priceInfo(product) {
    if (product?.price_info) return product.price_info;
    return {
        list_price: product?.price || 0,
        base_price: product?.price || 0,
        final_price: product?.price || 0,
        discount_amount: 0,
        discount_percent: 0,
        badge: null,
        ends_at: null,
    };
}

/* Форматирование «осталось N дней / часов / мин» */
export function promoTimeLeft(ends_at) {
    if (!ends_at) return '';
    const end = new Date(ends_at).getTime();
    const diff = end - Date.now();
    if (diff <= 0) return 'закончилась';
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    if (days > 0) return `ещё ${days} дн. ${hours} ч.`;
    if (hours > 0) return `ещё ${hours} ч. ${mins} мин.`;
    return `ещё ${mins} мин.`;
}